import api from './api';

const SubmissionService = {
  createOrGetDraft: (data) => api.post('/submissions/draft', data),
  getMySubmission: (competitionId) => api.get(`/submissions/me?competitionId=${competitionId}`),
  saveDraft: (id, data) => api.put(`/submissions/${id}/draft`, data),
  submit: (id, data) => api.post(`/submissions/${id}/submit`, data),
  getSubmission: (id) => api.get(`/submissions/${id}`),
  submitVideoPitch: (id, data) => api.post(`/submissions/${id}/video`, data),

  // Admin
  getAll: (params) => api.get('/submissions', { params }),
  advance: (id, data) => api.post(`/submissions/${id}/advance`, data),
  eliminate: (id) => api.post(`/submissions/${id}/eliminate`),
  selectWinner: (id) => api.post(`/submissions/${id}/select-winner`),
  startImplementation: (id) => api.post(`/submissions/${id}/start-implementation`),
  bulkAdvance: (data) => api.post('/submissions/bulk/advance', data),
  bulkEliminate: (data) => api.post('/submissions/bulk/eliminate', data),

  // Fundraising
  addFundraisingSource: (id, data) => api.post(`/submissions/${id}/fundraising/sources`, data),
  deleteFundraisingSource: (id, sourceId) => api.delete(`/submissions/${id}/fundraising/sources/${sourceId}`),
  verifyFundraisingSource: (id, sourceId) => api.post(`/submissions/${id}/fundraising/sources/${sourceId}/verify`),
  unverifyFundraisingSource: (id, sourceId) => api.post(`/submissions/${id}/fundraising/sources/${sourceId}/unverify`),
};

export default SubmissionService;
